<template>
<div class="searchlist">
  <div class="searchtop">
    <div @click="goInput()">
    </div>
    <img @click="goInput()" class="search" src="/static/img/search1.png">
    <span @click="goInput()">{{searchName?searchName:'请输入文件名称'}}</span>
    <img class="menu fr" src="/static/img/ctmenu.png"
    @click="popClick()">
  </div>
  <div class="searchmodel">
    <mt-popup v-model="popupsearch" position="top" modal=false closeOnClickModal = "false">
      <div class="searchbg">
        <div class="searchcontain">
          <input placeholder="请输入文件名称" type="text" class="searchInput" v-model="text">
          <img class="search" src="/static/img/search2.png">
          <span class="searchfind fr" @click="searchFile()">搜索</span>
        </div>
      </div>
    </mt-popup>
  </div>
  <div>
    <mt-popup v-model="popupVisible" position="top" modal=false>
      <div class="poptitle">
        文件状态
        <img src="/static/img/contract/close.png"
        @click="closeModal()">
      </div>
      <hr>
      <ul class="popul">
        <li class="fl" @click="totalfile()">
          <img class="" :src="status==1?'/static/img/contract/qb1.png':'/static/img/contract/qb.png'">
          <span :class="status==1?'cur':''">全部签署</span>
        </li>
        <li class="fl" @click="dwqsfile()">
          <img class="" :src="status==2?'/static/img/contract/dwqs1.png':'/static/img/contract/dwqs.png'">
          <span :class="status==2?'cur':''">待我签署</span>
        </li>
        <li class="fl" @click="dtrqsfile()">
          <img class="" :src="status==3?'/static/img/contract/dtrqs1.png':'/static/img/contract/dtrqs.png'">
          <span :class="status==3?'cur':''">待他人签署</span>
        </li>
        <li class="fl" @click="ywcfile()">
          <img class="" :src="status==4?'/static/img/contract/ywc1.png':'/static/img/contract/ywc.png'">
          <span :class="status==4?'cur':''">已完成</span>
        </li>
        <li class="fl" @click="cgxfile()">
          <img class="" :src="status==5?'/static/img/contract/cgx1.png':'/static/img/contract/cgx.png'">
          <span :class="status==5?'cur':''">草稿箱</span>
        </li>
        <li class="fl" @click="qtfile()">
          <img class="" :src="status==6?'/static/img/contract/qt1.png':'/static/img/contract/qt.png'">
          <span :class="status==6?'cur':''">其他文件</span>
        </li>
      </ul>
    </mt-popup>
  </div>
</div>
</template>
<script>
import cheader from '@/components/header';
export default {
  data () {
    return {
      popupVisible:false,
      popupsearch:false,
      text:'',
    }
  },
  props:['searchName','status'],
  methods: {
    popClick: function() {
      this.popupVisible = true;
    },
    closeModal:function() {
      this.popupVisible = false;
    },
    searchFile: function(){
      this.$emit('pageChange',this.text);
      switch (this.status) {
          case "1":
              this.popupsearch = false;
              this.$parent.getdtotalData(false,this.text);
              break;
          case "2":
              this.popupsearch = false;
              this.$parent.getdwqsData(false,this.text);
              break;
          case "3":
              this.popupsearch = false;
              this.$parent.getdtrqsData(false,this.text);
              break;
          case "4":
              this.popupsearch = false;
              this.$parent.getywcData(false,this.text);
              break;
          case "5":
              this.popupsearch = false;
              this.$parent.getcgxData(false,this.text);
              break;
          case "6":
              this.popupsearch = false;
              this.$parent.getqtData(false,this.text);
              break;
          default:
              this.popupsearch = false;
              this.$parent.getdtotalData(false,this.text);
              break;
      }
    },
    totalfile:function() {
      this.closeModal();
      this.$emit('pageChange',this.text)
      this.$parent.status = "1";
      localStorage.setItem("clist_status", '1');
      this.$parent.getdtotalData(false,this.text);
    },
    dwqsfile:function() {
      this.closeModal();
      this.$emit('pageChange',this.text)
      this.$parent.status = "2";
      localStorage.setItem("clist_status", '2');
      this.$parent.getdwqsData(false,this.text);
    },
    dtrqsfile:function() {
      this.closeModal();
      this.$emit('pageChange',this.text)
      this.$parent.status = "3";
      localStorage.setItem("clist_status", '3');
      this.$parent.getdtrqsData(false,this.text);
    },
    ywcfile:function() {
      this.closeModal();
      this.$emit('pageChange',this.text)
      this.$parent.status = "4";
      localStorage.setItem("clist_status", '4');
      this.$parent.getywcData(false,this.text);
    },
    cgxfile:function() {
      this.closeModal();
      this.$emit('pageChange',this.text)
      this.$parent.status = "5";
      localStorage.setItem("clist_status", '5');
      this.$parent.getcgxData(false,this.text);
    },
    qtfile:function() {
      this.closeModal();
      this.$emit('pageChange',this.text)
      this.$parent.status = "6";
      localStorage.setItem("clist_status", '6');
      this.$parent.getqtData(false,this.text);
    },
    goInput:function() {
      this.popupsearch = true;
    }
  },
  mounted(){
    
  },
  components:{
    cheader
  }
}
</script>
<style>
.searchlist ul{
  list-style: none;
  text-align:center;
}
.searchtop{
  position: relative;
  height:38px;
  line-height:38px;
  background-color:#1f74d8;
  padding-top: 8px;
}
.searchtop div{
  width:75%;
  height:30px;
  line-height: 30px;
  background-color: #f0f0f0;
  filter:alpha(Opacity=20);
  -moz-opacity:0.2;
  -webkit-opacity:0.2;
  -o-opacity:0.2;
  opacity: 0.2;
  /*-ms-border-radius: 26px;
  -moz-border-radius: 26px;
  -o-border-radius: 26px;
  -webkit-border-radius: 26px;
  border-radius: 26px;*/
  margin:0px 0 5px 20px;
}
.searchtop .menu{
  width:24px;
  margin:-28px 20px 0 0;
}
.searchtop .search{
  position: absolute;
  width:16px;
  top:16px;
  left:38px;
}
.searchtop span{
  position: absolute;
  font-size: 0.9rem;
  color: #ffffff;
  top:6px;
  left:68px;
}
.poptitle{
  height:45px;
  line-height: 45px;
  color: #7d7d7d;
  font-size: 1.1rem;
  text-align: center;
  margin-left:28px;
}
.poptitle img{
  float:right;
  width:16px;
  margin:14px 14px 0 0;
}
.mint-popup-top{
  width:100%;
}
.popul{
  width: 100%;
  margin: 1rem auto;
}
.popul li{
  width:33%;
  margin-bottom: 1rem;
}
.popul span{
  display: block;
  color: #7d7d7d;
  font-size: 0.8rem;
}
.popul .cur{
  color:#26a2ff;
}
.popul li img{
  width: 30px;
}


.searchmodel .v-modal{
  opacity: 1;
  background: #f2f2f2;
}
.searchbg{
  height:100%;
  background-color: #f0f0f0;
}
.searchcontain{
  position: relative;
  height:45px;
  height:45px;
  background-color: #1f74d8;
}
.searchInput{
  width:55%;
  height:30px;
  line-height: 30px;
  border:1px solid #d7d7d7;
  /*-ms-border-radius: 26px;
  -moz-border-radius: 26px;
  -o-border-radius: 26px;
  -webkit-border-radius: 26px;
  border-radius: 26px;*/
  margin:7px 0 0 20px;
  padding-left: 45px;
}
.searchcontain .search{
  position: absolute;
  width:16px;
  top:14px;
  left:38px;
}
.searchfind{
  color: #ffffff;
  display: inline-block;
  margin: 10px 20px 0 0;
}
</style>





// WEBPACK FOOTER //
// src/components/search.vue